import { Box } from '@material-ui/core';
import * as d3 from 'd3';
import React from 'react';
import { LegendIntervalsGq } from './TrafficIntervals';

export interface TableCellItemProps {
  value: number;
  total: number;
  minValue: number;
  maxValue: number;
  intervals: LegendIntervalsGq[];
  textColor: string;
}

export const TableCellItem: React.FC<TableCellItemProps> = ({
  value,
  total,
  minValue,
  maxValue,
  intervals,
  textColor,
}) => {
  let marketShareScaled = 0;
  // Normal case scaling
  if (total !== 0 && minValue !== maxValue) {
    const minMarketShare = total > 0 ? minValue / total : 0;
    const maxMarketShare = total > 0 ? maxValue / total : 0;
    const marketShare = total > 0 ? value / total : 0;
    marketShareScaled =
      total > 0 ? (marketShare - minMarketShare) / (maxMarketShare - minMarketShare) : 0;
  }

  // Show "OK" color for all if they're the same
  if (minValue == maxValue && total !== minValue) {
    marketShareScaled = 0.5; // OK/Yellow
  }
  // Show "Good" color if there's just one
  if (minValue == maxValue && total === minValue && total > 0) {
    marketShareScaled = 0.5; // Good/Green
  }

  const valueBgColor = intervals.find(
    (x) => marketShareScaled >= x.start && (x.end === null ? true : marketShareScaled < x.end)
  )?.bgcolor;

  return (
    <div
      className="flex items-center justify-center w-full h-[40px] border border-solid border-white rounded-sm text-sm"
      style={{ backgroundColor: valueBgColor, color: textColor }}
    >
      {value < 1000 ? d3.format('.1s')(Math.round(value)) : d3.format('.2s')(Math.round(value))}
    </div>
  );
};

export default TableCellItem;
